<template>
    <div class="container">
        <v-card>
                <v-card-title class="titulopagina">ADMINISTRAR POZOS</v-card-title>
                <v-card-text>
                    <v-btn color="green" fab small dark @click="crear">
                         <v-icon>add</v-icon>
                    </v-btn>
                </v-card-text>
                <!-- <Tabla :ajustes="this.ajustes" @editar="editar($event)"></Tabla> -->
            </v-card>

            <data-table class="mt-5" @editar="editar($event)"></data-table>

            <modal @peticionrealizada="cargarDatos"></modal>
    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex'
//import Tabla from '@/components/shared/Tabla.vue'
import Data_Table from '@/components/shared/Data_Table.vue'
import Modal from '@/components/shared/Modal.vue'
// import axios from 'axios'
export default {
    data:()=>({
        lista:[],
        lineas:[],
        inputs:[
            {tipo:'numero',valor:'',label:'Nro Pozo*',key:'nro_pozo'},
            {tipo:'texto',valor:'',label:'Descripción*',key:'descripcion'},
            {tipo:'select',valor:'',label:'Seleccione Línea*',key:'lineas_id',opciones:[],texto:'nombre_linea',seleccion:'id'},

        ],
        configuracion_modal:{
            titulo_modal:'',
            boton_submit:'',
            ruta:'',
            tipo_peticion:''
        },
        //configuracion para datatable
        cabeceras:[
                {
                    text:'Numero Pozo',
                    align:'center',
                    sortable:true,
                    filterable:true,
                    value:'nro_pozo',
                    class:'cabecera'
                },
                {
                    text: 'Descripción',
                    align: 'center',
                    sortable: true,
                    value: 'descripcion',
                    class:'cabecera'
                },
                {
                    text: 'Línea',
                    align: 'center',
                    sortable: true,
                    value: 'lineas.nombre_linea',
                    class:'cabecera'
                },
                { text: 'Acciones', value: 'action', sortable: false, align:'center', class:'cabecera' },
        ],
        acciones:[
                {key:'editar',titulo:'Editar',visible:true}
        ]
    }),
    created() {
        // Event.$on('peticion_realizada',()=>{
        //     this.cargarDatos()
        // })
    },
    mounted() {
        this.cargarDatos()
    },
    methods: {
        async cargarDatos(){
            await this.cargarLineas()
            //this.mostrarLoading('Cargando Datos...')
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

            let url = `${this.base_url}pozos`
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('respuesta',response);
                this.lista = response.data.data
                // response.data.data.forEach(item => {
                //     this.lista.push({id:item.id,tipo_equipo:item.tipo_equipo})
                // });
                Event.$emit('actualizar_lista',this.lista);
                Event.$emit('llenar_tabla',this.lista,this.cabeceras,this.acciones)
                Event.$emit('inicializar_tabla',this.cabeceras,this.lista,this.acciones)
                this.ocultarLoading()
            }).catch((error)=>{
                console.log(error)
                this.ocultarLoading()
            })
        },
        async cargarLineas(){
            //this.mostrarLoading('Cargando Líneas...')
            this.mostrarLoading({titulo:'Cargando Líneas...',color:'green'})

            let url = `${this.base_url}lineas`
            await this.axios.get(url,this.headers).then((response)=>{
                this.inputs[2].opciones = response.data.data
                this.lineas = response.data.data
                this.ocultarLoading()
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading()
            })
        },
        crear(){
            console.log('crear');
            this.configuracion_modal.titulo_modal = 'Crear Pozo'
            this.configuracion_modal.boton_submit = 'Crear'
            this.configuracion_modal.ruta = 'pozos'
            this.configuracion_modal.tipo_peticion = 'POST'
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },
        async editar($event){
            console.log('editando',$event);
            //por cada input se realiza el seteo correspondiente del item que se esta editando
            await this.inputs.forEach(input => {
                //recorrido del objeto a editar
                Object.keys($event).forEach(key => {
                    let valor = $event[key];
                    if(input.key == key){
                        input.valor = valor
                    }
                });
            });
            let linea = await this.$buscarObjeto($event['lineas_id'],this.lineas)
            this.inputs[2].valor = linea

            console.log('inputs con datos a editar',this.inputs);
            this.configuracion_modal.titulo_modal = 'Editar Pozo'
            this.configuracion_modal.boton_submit = 'Actualizar'
            this.configuracion_modal.ruta = `pozos/${$event.id}`
            this.configuracion_modal.tipo_peticion = 'PUT'
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
    components:{
        'modal':Modal,
        'data-table':Data_Table
    }
}
</script>